import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * React Router varsayılan olarak sayfa geçişlerinde scroll'u sıfırlamaz.
 * Bu komponent route değiştiğinde sayfayı en üste alır.
 * Hash varsa (örn. #section) tarayıcı doğal davranışıyla hedefe gidebilsin diye karışmayız.
 */
export default function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [location.pathname, location.search, location.hash]);

  return null;
}

